import { Component, EventEmitter, Input, Output } from '@angular/core';
import { constants } from 'src/app/config/constants';

@Component({
  selector: 'app-datatable-header',
  templateUrl: 'datatable-header.component.html'
})
export class DatatableHeaderComponent {

  @Input() headerTitle: string;
  @Input() headerDroupdown: Boolean;
  @Output() pageChange: EventEmitter<any> = new EventEmitter();
  itemPerPage: number = constants.rowsPerPage;
  rowsPerPageOptions: number[] = constants.rowsPerPageOptions;

  onChangePerPage(record) {
    this.itemPerPage = record;
    this.pageChange.emit(this.itemPerPage);
  }
}
